import * as Config from '../../../Config';

/**
 * @type interface
 */
export interface IStoreState {
	lastSeenVersion: string | null;
	seenVersions: string[];
	versionFirstSeenDates: Record<string, number>;
}

/**
 * @class State
 * @package Store/Module/VersionHistory
 * @project ChalkySticks App
 */
const state: IStoreState = {
	lastSeenVersion: null,
	seenVersions: [Config.App.VERSION_HISTORY_START_VERSION],
	versionFirstSeenDates: {},
};

export default state;
